import { Paper, Table, TableBody, TableContainer, TableHead, TableRow, TableCell } from '@mui/material';
import { useStyles } from './styles/ControlTable.styles';
import { SortDescendingIcon } from '@assets/index';
import { SortDirections } from '@/types/sort';
import { forwardRef } from 'react';

import type { ForwardedRef } from 'react';

export type ColumnHeaderProps = {
    label: string;
    width: number;
} & (
    | {
          sortable: true;
          direction: SortDirections;
          onSort: (direction: SortDirections) => void;
      }
    | {
          sortable?: false;
          direction?: never;
          onSort?: never;
      }
);

export const ColumnHeader = ({ label, width, sortable, direction, onSort }: ColumnHeaderProps) => {
    const toggleSort = () => {
        const newDirection = direction === SortDirections.ASC ? SortDirections.DESC : SortDirections.ASC;

        if (onSort) {
            onSort(newDirection);
        }
    };

    return (
        <TableCell style={{ minWidth: width, padding: '10px' }} onClick={() => toggleSort()}>
            {label}

            {sortable &&
                (direction === SortDirections.DESC ? (
                    <SortDescendingIcon style={{ marginLeft: '5px' }} />
                ) : (
                    <SortDescendingIcon style={{ transform: 'rotate(180deg)', marginLeft: '5px' }} />
                ))}
        </TableCell>
    );
};

export interface TableProps {
    headers: ColumnHeaderProps[];
    maxHeight?: number;
    minHeight?: number;
    children: React.ReactNode;
}

export const GenericTable = forwardRef(({ headers, children, maxHeight, minHeight }: TableProps, ref) => {
    const classes = useStyles();

    return (
        <Paper className={classes.wrapper} style={{ marginTop: '20px' }} elevation={0}>
            <TableContainer
                className={classes.container}
                sx={{ maxHeight, minHeight }}
                ref={ref as ForwardedRef<HTMLDivElement | null>}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {headers.map((col: any) => {
                                return (
                                    <ColumnHeader
                                        key={col.label}
                                        label={col.label}
                                        width={col.width}
                                        sortable={col.sortable}
                                        direction={col.direction}
                                        onSort={col.onSort}
                                    />
                                );
                            })}
                        </TableRow>
                    </TableHead>

                    <TableBody>{children}</TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
});
